import axios_instance from "../axios.config";

const GetTcCount = async (academic_year: string) => {
  const payload = {
    academic_year,
  };
  const response = await axios_instance.post("/tc/get-tc-count", payload);
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return null;
  }
};

const IncreaseTCCount = async (applicationData: any) => {
  try {
    const { user, arrayOfItems } = applicationData;

    const payload = {
      user,
      arrayOfItems,
    };
    const response = await axios_instance.post(
      "/tc/increase-tc-count",
      payload
    );
    console.log(response);
    if (response?.data?.status === "SUCCESS") {
      return response?.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log("Error Updating Students In Bulk");
    console.log(error);
    return [];
  }
};

export { GetTcCount, IncreaseTCCount };
